// extracted by mini-css-extract-plugin
export default {"container":"SalesEnablementMobileGuard_container__KKXHJ","message":"SalesEnablementMobileGuard_message__eAQGJ"};